import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  workFlowsList: [],
  workFlowSelected: null,
  stages : [],
  polls : [],
  contentPoll:[],
  isLoadingFetch : false,
  isLoadingStages : false,
};

const workFlowSlice = createSlice({
  name: "workFlow",
  initialState,
  reducers: {
    setWorkFlowsList(state, action) {
      return { ...initialState, workFlowsList: action.payload };
    },
    setWorkFlowSelected(state, action) {
      return { ...state, workFlowSelected: action.payload };
    },
    setStages(state, action) {
      return { ...state, stages: action.payload };
    },
    setPolls(state, action) {
      return { ...state, polls: action.payload };
    },
    setContentPoll(state, action) {
      return { ...state, contentPoll: action.payload };
    },
    setIsLoadingFetch(state, action) {
      return { ...state, isLoadingFetch: action.payload };
    },
    setIsLoadingStage(state, action) {
      return { ...state, isLoadingStages: action.payload };
    },
  },
});

export const {
    setWorkFlowsList,
    setIsLoadingFetch,
    setIsLoadingStage,
    setStages,
    setWorkFlowSelected,
} = workFlowSlice.actions;

export default workFlowSlice.reducer;